import { RootState } from "../../../index";

export const LifecycleStages=(state: RootState) => state?.lifecycleStage?.data?.lifecycleStages;
export const LifecycleStage=(state: RootState) => state?.lifecycleStage?.data?.lifecycleStage;
// export const LifecycleStageChangeState=(state: RootState) => state?.lifecycleStage?.data?.stageChangeMessage;